<template>
  <ContainerWrapper class="OffersContainer">
    <JbPrimeServiceAttendantContainer />
    <RequestedOffersListContainer class="requested-offers" />
    <div class="loan-offers">
      <NoCollateralOffersListContainer
        :style="cptdLoansOrder['no-collateral']"
      />
      <PayrollOffersListContainer
        v-if="enablePayroll"
        :style="cptdLoansOrder['payroll']"
      />
      <CreditCardEquityOffersListContainer
        :style="cptdLoansOrder['credit-card-equity']"
      />
      <FgtsOffersListContainer :style="cptdLoansOrder['fgts']" />
      <HomeEquityOffersListContainer :style="cptdLoansOrder['home-equity']" />
      <HomeEquityPayrollOffersListContainer
        :style="cptdLoansOrder['home-equity']"
      />
      <AutoEquityOffersListContainer :style="cptdLoansOrder['auto-equity']" />
      <PayrollAnticipationOffersListContainer
        :style="cptdLoansOrder['payroll-anticipation']"
      />
      <PixOffersListContainer :style="cptdLoansOrder['pix']" />
    </div>
    <AnnouncementsContainer />
    <AdManagerSlot
      v-if="!(cptdUserHasProposedOrValidatingOffers || cptdUserHasColdOffers)"
      ad-unit-path="/22834235630/cp.jurosbaixos.com.br/Cp_Content2"
    />
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import onlyUnique from '@/helpers/onlyUnique'
import { createNoEncondedUrlQueryParams } from '@/helpers/url'
import RequestedOffersListContainer from '@/containers/loans/RequestedOffersListContainer.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import JbPrimeServiceAttendantContainer from '@/containers/jb-prime/JbPrimeServiceAttendantContainer.vue'
import AutoEquityOffersListContainer from '@/containers/loans/auto/AutoEquityOffersListContainer.vue'
import FgtsOffersListContainer from '@/containers/loans/fgts/FgtsOffersListContainer.vue'
import HomeEquityOffersListContainer from '@/containers/loans/home-equity/HomeEquityOffersListContainer.vue'
import HomeEquityPayrollOffersListContainer from '@/containers/loans/home-equity-payroll/HomeEquityPayrollOffersListContainer.vue'
import NoCollateralOffersListContainer from '@/containers/loans/no-collateral/NoCollateralOffersListContainer.vue'
import AdManagerSlot from '@/components/ads/AdManagerSlot.vue'
import PayrollOffersListContainer from '@/containers/loans/payroll/PayrollOffersListContainer.vue'
import CreditCardEquityOffersListContainer from '@/containers/loans/credit-card-equity/CreditCardEquityOffersListContainer.vue'
import PayrollAnticipationOffersListContainer from '@/containers/loans/payroll-anticipation/PayrollAnticipationOffersListContainer.vue'
import PixOffersListContainer from '~/containers/loans/pix/PixOffersListContainer.vue'
import AnnouncementsContainer from '~/containers/loans/announcements/AnnouncementsContainer.vue'
export default {
  name: 'OffersContainer',
  components: {
    AnnouncementsContainer,
    PixOffersListContainer,
    PayrollAnticipationOffersListContainer,
    CreditCardEquityOffersListContainer,
    PayrollOffersListContainer,
    AdManagerSlot,
    RequestedOffersListContainer,
    ContainerWrapper,
    JbPrimeServiceAttendantContainer,
    AutoEquityOffersListContainer,
    FgtsOffersListContainer,
    HomeEquityOffersListContainer,
    HomeEquityPayrollOffersListContainer,
    NoCollateralOffersListContainer,
  },
  data() {
    return {
      enablePayroll: false,
    }
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
      gtAllOnGoingNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllOnGoingNoCollateralOffers',
      gtAutoColdOffers:
        'products/loans/auto-equity/cold-offer/gtAutoColdOffers',
      gtAllProposedAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllProposedAutoOffers',
      gtAllOnGoingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllOnGoingAutoOffers',
      gtAllValidatingAutoOffers:
        'products/loans/auto-equity/auto-equity/gtAllValidatingAutoOffers',
      gtHomeEquityColdOffers:
        'products/loans/home-equity/cold-offer/gtHomeEquityColdOffers',
      gtAllProposedHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllProposedHomeEquityOffers',
      gtAllValidatingHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllValidatingHomeEquityOffers',
      gtAllOnGoingHomeEquityOffers:
        'products/loans/home-equity/home-equity/gtAllOnGoingHomeEquityOffers',
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
      gtLastLoanInteraction: 'ui/user-activity/gtLastLoanInteraction',
    }),
    cptdLoansOrder() {
      return {
        'auto-equity': this.getProductDisplayOrderStyle('auto-equity'),
        fgts: this.getProductDisplayOrderStyle('fgts'),
        'no-collateral': this.getProductDisplayOrderStyle('no-collateral'),
        'home-equity': this.getProductDisplayOrderStyle('home-equity'),
        'credit-card-equity':
          this.getProductDisplayOrderStyle('credit-card-equity'),
        payroll: this.getProductDisplayOrderStyle('payroll'),
        'payroll-anticipation': this.getProductDisplayOrderStyle(
          'payroll-anticipation',
        ),
        pix: this.getProductDisplayOrderStyle('pix'),
      }
    },
    cptdAllProposedOrValidatingOffers() {
      return [
        ...this.gtAllProposedNoCollateralOffers,
        ...this.gtAllProposedAutoOffers,
        ...this.gtAllValidatingAutoOffers,
        ...this.gtAllProposedHomeEquityOffers,
        ...this.gtAllValidatingHomeEquityOffers,
      ]
    },
    cptdAllOngoingOffers() {
      return [
        ...this.gtAllOnGoingNoCollateralOffers,
        ...this.gtAllOnGoingAutoOffers,
        ...this.gtAllOnGoingHomeEquityOffers,
      ]
    },
    cptdAllColdOffers() {
      return [...this.gtAutoColdOffers, ...this.gtHomeEquityColdOffers]
    },
    cptdUserHasColdOffers() {
      return this.cptdAllColdOffers.length > 0
    },
    cptdUserHasProposedOrValidatingOffers() {
      return this.cptdAllProposedOrValidatingOffers.length > 0
    },
    cptdUserHasOngoingOffers() {
      return this.cptdAllOngoingOffers.length > 0
    },
  },
  mounted() {
    this.setMarketingCampaignUrlQueryParams()
  },
  methods: {
    getProductDisplayOrderStyle(product) {
      return `order: ${this.gtLastLoanInteraction.indexOf(product)}`
    },
    setMarketingCampaignUrlQueryParams() {
      const allProductsProposedOffersPartnersUniqueFilter =
        this.cptdAllProposedOrValidatingOffers
          .map(({ partner = '' }) => partner.toLowerCase())
          .filter(onlyUnique)

      const coldOffersPartnersUniqueFilter = [
        ...this.gtAutoColdOffers,
        ...this.gtHomeEquityColdOffers,
      ]
        .map(({ partner }) => `${partner}_co`.toLowerCase())
        .filter(onlyUnique)

      const partners = [
        ...allProductsProposedOffersPartnersUniqueFilter,
        ...coldOffersPartnersUniqueFilter,
      ]
        .sort()
        .join('-')

      const { annotated, income_source } = this.personaData?.finance || {}
      const { score } = this.gtCreditScoreLatest?.data || {}

      history.replaceState(
        history.state,
        'ofertas',
        createNoEncondedUrlQueryParams({
          ...(partners.length && { partners, status: 'aguardando' }),
          ...(annotated !== undefined && annotated !== '' && { annotated }),
          ...(score !== undefined && { score }),
          ...(!!income_source && { income_source }),
        }),
      )
    },
  },
}
</script>
<style lang="scss">
.OffersContainer {
  .ad-wrapper {
    display: flex;
  }
  & > .JbPrimeCallToActionCard {
    margin: 32px 0 0 0;
  }
  & > .requested-offers {
    margin-top: 4px;
  }
  & > .requested-offers + .loan-offers {
    margin-top: 0;
  }

  & > .loan-offers {
    display: flex;
    flex-direction: column;
    margin-top: 4px;

    & > .ContainerWrapper {
      width: 100%;
    }
  }
}
</style>
